import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "#193446",
    color: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="12" cy="12" r="10" fill="inherit"/> <path d="M11.308 14.071h1.384L13 10.93V7h-2v3.929l.308 3.142ZM11 17h2v-2h-2v2Z" fill="currentColor"/>' }
  })
);